/**
 * 算法工具共享界面
 */

import React, { Component } from 'react'
import { connect } from 'react-redux';
import axios from 'axios'
import moment from 'moment'
import './index.css'
import { Radio, Checkbox, Pagination, Input, DatePicker, Select, Modal, message } from 'antd';
import {
  algSatelliteTypeOptions,//卫星种类
  algSatelliteNameOptions,//卫星名称
  algSatelliteSensorOptions,//卫星载荷
} from '../components/publicData'
import { getPeriodicTime, removeRepeatPropertyFromArray } from '../components/publicFunctions'
import DownloadFileComponent from '../components/downFileComponent'
import Header4 from 'src/components/Header/Header4'
import refresh from '../static/refresh.png'
import submenu from '../static/submenu.png'
import more from '../static/more.png'
import download from '../static/download.png'
import detailed from '../static/detailed.png'
import nodata from '../static/nodata.png'
import ToolImg from '../static/ToolImg.png'

const { RangePicker } = DatePicker
const { Option } = Select;
const CheckboxGroup = Checkbox.Group
const dateFormat = "YYYY-MM-DD"
const getScoreRoot = global.url ? global.url.score : null;
let isShowAdvancedSearchCondition = false//是否展示高级检索
class AlgorithmToolsSharing extends Component {

  state = {
    diffAlgorithmToolTypeScore: 0,//不同类型模型所需分数
    downLoadTotalScore: 0,//下载模型所需的总积分
    isDownloadModalShown: false,//是否显示下载框
    downloadList: [],//下载列表
    userScore: 0,//用户积分
    toolType: undefined,//工具类型选择
    toolName: null,//工具名称
    toolKeyWord: '',//工具关键字
    toolStartTime: '',//工具测量开始时间
    toolEndTime: '',//工具测量结束时间
    toolAuthor: null,//工具作者
    toolVersion: null,//工具版本
    toolSatelliteType: undefined,//卫星种类
    toolSatelliteSensor: undefined,//卫星载荷
    toolSatelliteName: undefined,//卫星名称
    toolsTypeList: [],//通过查询数据库，检索到的软件工具类型列表
    algorithmToolsList: [],//检索到的算法模型列表
    algorithmToolsTotal: 0,//检索到的软件工具总数
    algorithmToolsPageNumber: 1,//当前所在页码数
    toolsCheckedList: [],//选中欲下载的算法模型列表
    indeterminate: false,//全选按钮的中间状态
    isCheckedTotalAlg: false,//是否全选中
    isDetailModalShown: false,//是否显示详情框
    currentCheckedItem: null,//当前查看详情的数据项
    who:null
  }

  componentDidMount() {
    this.init()
    this.getDiffTypeDataScore()
  }

  componentDidUpdate(preProps, preState) {
    if (preProps.zd_user.userId !== this.props.zd_user.userId) this.init();
    if (preState.toolType !== this.state.toolType) this.getDiffTypeDataScore()
  }

  init() {
    if (!this.props.zd_user.token) return;
    this.getUserScore();
    this.getAllToolsTypeList();
  }

  /* 获取浙大所有工具类型 */
  getAllToolsTypeList = () => {
    const { zd_user } = this.props;
    axios.get(`/zdUrl/api/getGeneralToolType`, {
      headers: {
        Authorization: zd_user.token,
      }
    }
    ).then(res => {
      if (res.data.code === "0") {
        let data = res.data.data;
        this.setState({ toolsTypeList: [...data], })
      }
      else {
        message.error(res.data.info);
      }
    }).catch((e) => {
      message.error("检索失败，请检查网络连接……")
      console.log(e);
    })
  }

  //获取模型算法下载所需积分
  getDiffTypeDataScore = async () => {
    const { data: res } = await axios.get(getScoreRoot + '/type/list')
    // console.log('getDiffTypeDataScore---', res)
    if (res.code === '200') {
      res.payload.map(element => {
        if (element.resourceType === "通用工具检验模型") {
          this.setState({
            diffAlgorithmToolTypeScore: element.downloadScore
          })
          return
        }
      })
    } else {
      message.error('算法模型下载积分获取失败!')
    }
  }
  // 获取用户积分
  getUserScore = async () => {
    if (!this.props.user.userId) return
    axios({
      url: global.url.score + '/score/getbyid',
      method: 'get',
      params: {
        userId: this.props.user.userId,
      },
      headers: {
          'Authorization': this.props.user.token
      }
    }).then(res => {
      // console.log("getUserScore", res)
      if (res.data.code === '200' && res.data.payload) {
        this.setState({ userScore: res.data.payload.score })
      } else {
        message.error('用户积分查询错误或用户积分不存在');
      }
    }).catch(err => {
      console.log(err);
      message.error('用户积分查询错误或用户积分不存在');
    })
  }

  // 展示高级检索条件区域
  showAdvancedSearchCondition = () => {
    if (!isShowAdvancedSearchCondition) {
      document.getElementById('advanced-search-condition').style.height = '630px'
      document.getElementById('algorithmToolsSharing-advanced-search-condition').setAttribute('style', 'display:block')
      document.getElementById('advanced-icon').style.transform = 'rotate(180deg)'
      isShowAdvancedSearchCondition = !isShowAdvancedSearchCondition
    } else {
      document.getElementById('advanced-search-condition').style.height = '432px'
      document.getElementById('algorithmToolsSharing-advanced-search-condition').setAttribute('style', 'display:none')
      document.getElementById('advanced-icon').style.transform = 'rotate(0deg)'
      isShowAdvancedSearchCondition = !isShowAdvancedSearchCondition
    }
  }

  // 重置检索条件
  resetSearchConditions = () => {
    this.setState({
      toolType: undefined,//工具类型选择
      toolName: null,//工具名称
      toolKeyWord: '',//工具关键字
      toolStartTime: '',//工具测量开始时间
      toolEndTime: '',//工具测量结束时间
      toolAuthor: null,//工具作者
      toolVersion: null,//工具版本
      toolSatelliteType: undefined,//卫星种类
      toolSatelliteSensor: undefined,//卫星载荷
      toolSatelliteName: undefined,//卫星名称
      who:null
    })
  }

  // 选择框的统一方法
  changeSelectFrameValue = (selectFrameName, value) => {
    switch (selectFrameName) {
      // 设置工具类型
      case '工具类型选择':
        this.setState({
          toolType: value
        })
        break;
      // 设置时间段
      case '时间段选择':
        this.setState({
          toolStartTime: value[0],
          toolEndTime: value[1]
        })
        break;
      // 设置卫星种类属性值
      case '卫星种类':
        this.setState({
          toolSatelliteType: value,
          toolSatelliteName: undefined,
          toolSatelliteSensor: undefined
        })
        break;
      // 设置卫星名称属性值
      case '卫星名称':
        this.setState({
          toolSatelliteName: value,
          toolSatelliteSensor: undefined
        })
        break;
      // 设置卫星载荷属性值
      case '卫星载荷':
        this.setState({
          toolSatelliteSensor: value
        })
        break;
      case '平台/个人':
        this.setState({
          who: value
        })
        break;
      default:
        break;
    }
  }

  // 输入框的统一方法
  changeInputFrameValue = (inputFrameName, event) => {
    switch (inputFrameName) {
      case '工具名称':
        this.setState({
          toolName: event.target.value
        })
        break;
      case '关键字':
        this.setState({
          toolKeyWord: event.target.value
        })
        break;
      case '快速选择时间':
        let startTime = getPeriodicTime(new Date().getTime(), event.target.value)
        let endTime = moment(new Date(), dateFormat)
        this.setState({
          toolStartTime: startTime,
          toolEndTime: endTime
        })
        break;
      case '工具作者':
        this.setState({
          toolAuthor: event.target.value
        })
        break;
      case '工具版本':
        this.setState({
          toolVersion: event.target.value
        })
        break;
      default:
        break;
    }
  }

  // 获取软件工具
  getTools = async (pageNumber, pageSize) => {
    const { zd_user } = this.props;
    const {
      toolType,//工具类型选择
      toolName,//工具名称
      toolKeyWord,//工具关键字
      toolStartTime,//工具测量开始时间
      toolEndTime,//工具测量结束时间
      toolAuthor,//工具作者
      toolVersion,//工具版本
      toolSatelliteSensor,//卫星载荷
      toolSatelliteName,//卫星名称
      who
    } = this.state
    let searchParams = {
      type: toolType ? [toolType] : undefined,
      chsname: toolName,
      keyword: toolKeyWord,
      starttime: toolStartTime === '' ? -1 : toolStartTime,
      endtime: toolEndTime === '' ? -1 : toolEndTime,
      author: toolAuthor,
      version: toolVersion,
      satellite: toolSatelliteName,
      sensor: toolSatelliteSensor,
      page: pageNumber,
      num: pageSize
    }
    if(who) {
      searchParams.who = who
    }
    const { data: res } = await axios.post('/zdUrl/api/getGeneralToolData', searchParams, {
      headers: {
        Authorization: zd_user.token,
      }
    })
    if (res.code === '0') {
      console.log(res.data)
      return res.data
    } else {
      message('数据获取失败，请重试')
    }
  }

  searchAlgorithmTools = async (pageNumber, pageSize) => {
    const { toolType } = this.state//工具类型
    if (toolType === null || toolType === undefined) {
      message.error('请选择工具类型！')
    } else {
      let tools = await this.getTools(pageNumber, pageSize)
      this.setState({
        algorithmToolsList: tools.list,//检索到的算法模型列表
        algorithmToolsTotal: tools.total,//检索到的软件工具总数
        algorithmToolsPageNumber: pageNumber,//当前所在页码数
      })
    }
  }

  // 改变页码 
  changePaginationNumber = (pageNumber) => {
    // console.log(pageNumber)
    this.searchAlgorithmTools(pageNumber, 10)
    this.setState({
      isCheckedTotalAlg: false,
      indeterminate: false
    })
  }

  // 选中算法模型item项
  changeCheckList = (checkList) => {
    // console.log(checkList)
    // tempList = [...tempList, ...checkList]
    // tempList = removeRepeatPropertyFromArray(tempList)
    // console.log(tempList)
    this.setState({
      toolsCheckedList: checkList,
      indeterminate: checkList.length && checkList.length < this.state.algorithmToolsList.length,
      isCheckedTotalAlg: checkList.length === this.state.algorithmToolsList.length
    })
  }

  // 全选和取消全选
  checkedTotalAlgorithm = (event) => {
    this.setState({
      toolsCheckedList: event.target.checked ? this.state.algorithmToolsList : [],
      indeterminate: false,
      isCheckedTotalAlg: event.target.checked
    })
  }

  // 单个算法模型下载
  downloadSingleAlgorithm = (downItem) => {
    // console.log("downItem", downItem)
    downItem.score = this.state.diffAlgorithmToolTypeScore
    this.setState({
      downloadList: [downItem],
      downLoadTotalScore: downItem.score,
      isDownloadModalShown: true
    })
  }
  // 批量下载算法模型
  downloadMultipleAlgorithm = () => {
    let tempList = this.state.toolsCheckedList
    tempList.map(item => {
      item.score = this.state.diffAlgorithmToolTypeScore
    })
    let totalScore = this.state.diffAlgorithmToolTypeScore * tempList.length
    this.setState({
      downloadList: tempList,
      downLoadTotalScore: totalScore,
      isDownloadModalShown: true
    })
  }

  closeDownLoadModal = () => {
    this.setState({
      isDownloadModalShown: false,
    })
  }

  clearAlgCheckedList = () => {
    this.setState({
      toolsCheckedList: [],
      indeterminate: false,
      isCheckedTotalAlg: false
    })
  }

  closeDetailModal = () => {
    this.setState({
      isDetailModalShown: false
    })
  }

  showDetailModal = (detailItem) => {
    this.setState({
      isDetailModalShown: true,
      currentCheckedItem: detailItem
    })
  }

  render() {
    return (
      <div >
        <Header4></Header4>
        {/* 界面背景 */}
        <div className="algorithmToolsSharing-background">
          {/* 检索及结果界面 */}
          <div className="algorithmToolsSharing-content">
            {/* 界面左侧检索区域 */}
            <div className="algorithmToolsSharing-search-content" id="advanced-search-condition">
              {/* 检索区域标题行 */}
              <div className="algorithmToolsSharing-search-title">
                <div className="algorithmToolsSharing-search-text">处理工具检索</div>
                <div className="algorithmToolsSharing-search-reset">
                  <img src={refresh} className="algorithmToolsSharing-search-reset-img"></img>
                  <div className="algorithmToolsSharing-search-rest-text" onClick={() => this.resetSearchConditions()}>重置条件</div>
                </div>
              </div>
              {/* 工具类型选择 */}
              <div className="algorithmToolsSharing-search-ToolsType">
                <Select
                  allowClear
                  className="algorithmToolsSharing-search-ToolsType-select"
                  placeholder="工具类型选择"
                  value={this.state.toolType}
                  onChange={(e) => { this.changeSelectFrameValue('工具类型选择', e) }}
                >
                  {
                    this.state.toolsTypeList.map((toolsType, index) => {
                      return <Option value={toolsType} key={`${toolsType}-${index}`}>{toolsType}</Option>
                    })
                  }
                </Select>
              </div>
              {/* 工具名称 */}
              <div className="algorithmToolsSharing-search-ToolsName">
                <Input className="algorithmToolsSharing-search-ToolsName-input" placeholder="工具名称" onChange={(e) => { this.changeInputFrameValue('工具名称', e) }}></Input>
              </div>
              {/* 检索区域模型关键字行 */}
              <div className="algorithmToolsSharing-search-keyword">
                <Input className="algorithmToolsSharing-search-keyword-input" placeholder="关键字" onChange={(e) => { this.changeInputFrameValue('关键字', e) }}></Input>
              </div>
              {/* 检索区域模型测量时间行 */}
              <div className="algorithmToolsSharing-search-time">
                <RangePicker
                  className="algorithmToolsSharing-search-timepicker"
                  placeholder={['测量开始时间', '测量结束时间']}
                  format={dateFormat}
                  value={moment(this.state.toolStartTime, dateFormat)._isValid ? [moment(this.state.toolStartTime, dateFormat), moment(this.state.toolEndTime, dateFormat)] : ['', '']}
                  onChange={(_, e) => { this.changeSelectFrameValue('时间段选择', e) }}
                ></RangePicker>
              </div>
              <div className='algorithmModelSharing-search-default-other'>
                <Select
                  allowClear
                  className="algorithmModelSharing-search-produceType-select"
                  placeholder="平台/个人"
                  onChange={(e) => { this.changeSelectFrameValue('平台/个人',e) }}
                  value={this.state.who}
                  options={[{
                    value: 'admin',
                    label: '平台',
                  },
                  {
                    value: 'person',
                    label: '个人',
                  }]}
                ></Select>
              </div>
              {/* 检索区域模型测量预设时间行 */}
              <div className="algorithmToolsSharing-search-default-time">
                <Radio.Group className="algorithmToolsSharing-search-today" onChange={(e) => { this.changeInputFrameValue('快速选择时间', e) }}>
                  <Radio value={'day'} className="algorithmToolsSharing-search-today-radio">
                    <div title="一天内" className="algorithmToolsSharing-search-today-radio-text">一天内</div>
                  </Radio>
                  <Radio value={'week'} className="algorithmToolsSharing-search-today-radio">
                    <div title="一周内" className="algorithmToolsSharing-search-today-radio-text">一周内</div>
                  </Radio>
                  <Radio value={'month'} className="algorithmToolsSharing-search-today-radio">
                    <div title="一月内" className="algorithmToolsSharing-search-today-radio-text">一月内</div>
                  </Radio>
                  <Radio value={'year'} className="algorithmToolsSharing-search-today-radio">
                    <div title="一年内" className="algorithmToolsSharing-search-today-radio-text">一年内</div>
                  </Radio>
                </Radio.Group>
              </div>
              {/* 高级检索标题栏 */}
              <div className="algorithmToolsSharing-advanced-search-title">
                <div className="algorithmToolsSharing-advanced-search-area">
                  <div className="algorithmToolsSharing-advanced-search-img-wrap">
                    <img src={submenu} className="algorithmToolsSharing-advanced-search-img"></img>
                  </div>
                  <div className="algorithmToolsSharing-advanced-search-text"> 高级检索</div>
                </div>
                <img src={more} id="advanced-icon" className="algorithmToolsSharing-advanced-search-more"
                  onClick={() => this.showAdvancedSearchCondition()}
                ></img>
              </div>
              {/* 高级检索区域 */}
              <div className="algorithmToolsSharing-advanced-search-condition" id="algorithmToolsSharing-advanced-search-condition" style={{ display: 'none' }}>
                <div className="algorithmToolsSharing-advanced-search-toolsAuthor-toolsVersion-wrap">
                  {/* 工具作者 */}
                  <Input className="algorithmToolsSharing-advanced-search-toolsAuthor" placeholder="工具作者" onChange={(e) => { this.changeInputFrameValue('工具作者', e) }}></Input>
                  {/* 工具版本 */}
                  <Input className="algorithmToolsSharing-advanced-search-toolsVersion" placeholder="工具版本" onChange={(e) => { this.changeInputFrameValue('工具版本', e) }}></Input>
                </div>
                <div className="algorithmToolsSharing-advanced-search-satellite-type-sensor-wrap">
                  {/* 卫星种类 */}
                  <div className="algorithmToolsSharing-advanced-search-satelliteType-wrap">
                    <div className="algorithmToolsSharing-advanced-search-satelliteType-title">卫星种类</div>
                    <Select
                      allowClear
                      className="algorithmToolsSharing-advanced-search-satelliteType-select"
                      placeholder="全部"
                      options={algSatelliteTypeOptions}
                      onChange={(e) => this.changeSelectFrameValue('卫星种类', e)}
                      value={this.state.toolSatelliteType}
                    ></Select>
                  </div>
                  {/* 卫星载荷 */}
                  <div className="algorithmToolsSharing-advanced-search-satelliteSensor-wrap">
                    <div className="algorithmToolsSharing-advanced-search-satelliteSensor-title">卫星载荷</div>
                    <Select
                      allowClear
                      className="algorithmToolsSharing-advanced-search-satelliteSensor-select"
                      placeholder="全部"
                      options={algSatelliteSensorOptions[this.state.toolSatelliteType] ? algSatelliteSensorOptions[this.state.algSatelliteName] : null}
                      onChange={(e) => this.changeSelectFrameValue('卫星载荷', e)}
                      value={this.state.toolSatelliteSensor}
                    ></Select>
                  </div>
                </div>
                {/* 卫星名称 */}
                <div className="algorithmToolsSharing-advanced-search-satelliteName-wrap">
                  <div className="algorithmToolsSharing-advanced-search-satelliteName-title">卫星种类</div>
                  <Select
                    allowClear
                    className="algorithmToolsSharing-advanced-search-satelliteName-select"
                    placeholder="全部"
                    options={algSatelliteNameOptions[this.state.toolSatelliteSensor]}
                    onChange={(e) => this.changeSelectFrameValue('卫星名称', e)}
                    value={this.state.algSatelliteType}
                  ></Select>
                </div>
              </div>
              {/* 检索按钮区域 */}
              <div className="algorithmToolsSharing-search-buttom-wrap">
                <div className="algorithmToolsSharing-search-buttom" onClick={() => this.searchAlgorithmTools(1, 10)}>
                  检索
                </div>
              </div>
            </div>
            {/* 界面右侧结果区域 */}
            <div className="algorithmToolsSharing-result-content">
              {/* 检索结果区域头部标题栏 */}
              <div className="algorithmToolsSharing-result-content-title-wrap">
                <div className="algorithmToolsSharing-result-content-title">软件工具列表</div>
                <div className="algorithmToolsSharing-result-content-download-buttom">
                  <img src={download} className="algorithmToolsSharing-result-content-download-buttom-img"></img>
                  <div className="algorithmToolsSharing-result-content-download-buttom-text" onClick={() => this.downloadMultipleAlgorithm()}>批量提交下载订单</div>
                </div>
              </div>
              {/* 全选按钮区 */}
              <div className="algorithmToolsSharing-result-content-checkall-wrap">
                <Checkbox
                  className="algorithmToolsSharing-result-content-checkall-buttom"
                  indeterminate={this.state.indeterminate}
                  checked={this.state.isCheckedTotalAlg}
                  disabled={this.state.algorithmToolsList.length === 0 ? true : false}
                  onChange={(e) => { this.checkedTotalAlgorithm(e) }}
                >全选</Checkbox>
                <div className="algorithmToolsSharing-result-content-checkall-result">已勾选{this.state.toolsCheckedList.length}个算法</div>
              </div>
              {/* 检索结果区 */}
              <div className="algorithmToolsSharing-result-content-items-wrap">
                {
                  this.state.algorithmToolsList.length === 0 ?
                    <>
                      {/* 无检索结果 */}
                      <div className="algorithmToolsSharing-result-content-nodata-wrap">
                        <img src={nodata} className="algorithmToolsSharing-result-content-nodata-img"></img>
                      </div>
                    </> :

                    <>
                      {/* 检索结果列表 */}
                      <CheckboxGroup
                        className="algorithmToolsSharing-result-content-item-checkbox-group"
                        value={this.state.toolsCheckedList}
                        onChange={(value) => { this.changeCheckList(value) }}
                      >
                        {
                          this.state.algorithmToolsList.map((item, index) => {
                            return <div key={item.id} className="algorithmToolsSharing-result-content-item-checkbox-wrap">
                              <Checkbox value={item} className="algorithmToolsSharing-result-content-item-checkbox" ></Checkbox>
                              <div className={this.state.toolsCheckedList.indexOf(item) == -1 ? "algorithmToolsSharing-result-content-item-wrap" : "algorithmToolsSharing-result-content-item-wrap-checked"}>
                                {/* 检索结果项上部分内容 */}
                                <div className="algorithmToolsSharing-result-content-item-top-area">
                                  {/* 检索结果项上部分左侧属性信息 */}
                                  <div className="algorithmToolsSharing-result-content-item-topleft-area">
                                    {/* 中文名称/工具名称 */}
                                    <div className="algorithmToolsSharing-result-content-item-topleft-chanesename">{item.algorithmname}</div>
                                    <div className="algorithmToolsSharing-result-content-item-topleft-other-attributes">
                                      {/* 算法英文名 */}
                                      <div title={item.algorithmname} className="algorithmToolsSharing-result-content-item-topleft-other-attributes-englishname">{item.chsname}</div>
                                      {/* 产品种类 */}
                                      <div className="algorithmToolsSharing-result-content-item-topleft-other-attributes-produceType">{item.type}</div>
                                      {/* 算法级别*/}
                                      <div className="algorithmToolsSharing-result-content-item-topleft-other-attributes-toolLevel">LEVEL{item.algorithmlevel}</div>
                                      {/* 算法版本 */}
                                      <div className="algorithmToolsSharing-result-content-item-topleft-other-attributes-toolVersion">Version{item.version}</div>
                                    </div>
                                  </div>
                                  {/* 检索结果项上部分右侧属性信息 */}
                                  <div className="algorithmToolsSharing-result-content-item-topright-area">
                                    <div className="algorithmToolsSharing-result-content-item-topright-detailed-buttom">
                                      <img src={detailed} className="algorithmToolsSharing-result-content-item-topright-detailed-buttom-img"></img>
                                      <div className="algorithmToolsSharing-result-content-item-topright-detailed-buttom-text" onClick={() => this.showDetailModal(item)}>详情</div>
                                    </div>
                                    <div className="algorithmToolsSharing-result-content-item-topright-download-buttom">
                                      <img src={download} className="algorithmToolsSharing-result-content-item-topright-download-buttom-img"></img>
                                      <div className="algorithmToolsSharing-result-content-item-topright-download-buttom-text" onClick={() => { this.downloadSingleAlgorithm(item) }}>提交下载订单</div>
                                    </div>
                                  </div>
                                </div>
                                {/* 检索结果项下部分内容 */}
                                <div className="algorithmToolsSharing-result-content-item-bootom-area">
                                  {/* 检索结果项下部分左侧属性信息 */}
                                  <div className="algorithmToolsSharing-result-content-item-bootomleft-area">
                                    {/* 交互类型 */}
                                    <div className="algorithmToolsSharing-result-content-item-bootomleft-interactionType">
                                      <div className="algorithmToolsSharing-result-content-item-bootomleft-interactionType-attr-name">交互类型</div>
                                      <div className="algorithmToolsSharing-result-content-item-bootomleft-interactionType-attr-value">{item.artificial}</div>
                                    </div>
                                    {/* 卫星 */}
                                    <div className="algorithmToolsSharing-result-content-item-bootomleft-satelliteName">
                                      <div className="algorithmToolsSharing-result-content-item-bootomleft-satelliteName-attr-name">卫星</div>
                                      <div className="algorithmToolsSharing-result-content-item-bootomleft-satelliteName-attr-value">{item.satellite}</div>
                                    </div>
                                    {/* 传感器 */}
                                    <div className="algorithmToolsSharing-result-content-item-bootomleft-satelliteSensor">
                                      <div className="algorithmToolsSharing-result-content-item-bootomleft-satelliteSensor-attr-name">传感器</div>
                                      <div className="algorithmToolsSharing-result-content-item-bootomleft-satelliteSensor-attr-value">{item.sensor}</div>
                                      {/* <div className="algorithmModelSharing-result-content-item-bootomleft-satelliteSensor-attr-value">MSS</div> */}
                                    </div>
                                  </div>
                                  {/* 检索结果项下部分右侧属性信息 */}
                                  <div className="algorithmToolsSharing-result-content-item-bootomright-area">
                                    {/* 算法作者 */}
                                    <div className="algorithmToolsSharing-result-content-item-bootomright-algAuthor">
                                      <div className="algorithmToolsSharing-result-content-item-bootomright-algAuthor-attr-name">作者</div>
                                      <div title={item.author} className="algorithmToolsSharing-result-content-item-bootomright-algAuthor-attr-value">{item.author}</div>
                                    </div>
                                    {/* 积分 */}
                                    <div className="algorithmToolsSharing-result-content-item-bootomright-price">
                                      <div className="algorithmToolsSharing-result-content-item-bootomright-price-attr-name">积分</div>
                                      <div className="algorithmToolsSharing-result-content-item-bootomright-price-attr-value">{this.state.diffAlgorithmToolTypeScore}</div>
                                    </div>
                                    {/* 评分 */}
                                    <div className="algorithmToolsSharing-result-content-item-bootomright-score">
                                      <div className="algorithmToolsSharing-result-content-item-bootomright-score-attr-name">评分</div>
                                      <div className="algorithmToolsSharing-result-content-item-bootomright-score-attr-value">9.0</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          })
                        }
                        {/* 页脚区域 */}
                        <div className="algorithmToolsSharing-result-pagination-wrap-out">
                          <div className="algorithmToolsSharing-result-pagination-wrap-ininer">
                            <div className="algorithmToolsSharing-result-pagination-totalNum">共{this.state.algorithmToolsList.length}条数据</div>
                            <Pagination
                              showQuickJumper
                              showSizeChanger={false}
                              total={this.state.algorithmToolsTotal}
                              current={this.state.algorithmToolsPageNumber}
                              onChange={(value) => { this.changePaginationNumber(value) }}
                              defaultPageSize={10}
                              className="algorithmToolsSharing-result-pagination"
                            ></Pagination>
                          </div>
                        </div>
                      </CheckboxGroup>
                    </>
                }
              </div>
            </div>
          </div>
        </div>
        <Modal
          className="algorithmToolsSharing-detail-modal"
          title='工具详情'
          footer={null}
          onCancel={() => this.closeDetailModal()}
          visible={this.state.isDetailModalShown}
        >
          {
            this.state.currentCheckedItem ? <>
              <div className="algorithmToolsSharing-detail-modal-top-area">
                <img src={ToolImg} className="algorithmToolsSharing-detail-modal-img"></img>
                <div className="algorithmToolsSharing-detail-modal-top-right-area">
                  <div className="algorithmToolsSharing-detail-modal-tool-chsName-wrap">
                    <div className="algorithmToolsSharing-detail-modal-tool-chsName-title">工具名称:</div>
                    <div className="algorithmToolsSharing-detail-modal-tool-chsName-vaiue">{this.state.currentCheckedItem.chsname}</div>
                  </div>
                  <div className="algorithmToolsSharing-detail-modal-tool-algorithmname-wrap">
                    <div className="algorithmToolsSharing-detail-modal-tool-algorithmname-title">工具简称:</div>
                    <div className="algorithmToolsSharing-detail-modal-tool-algorithmname-vaiue">{this.state.currentCheckedItem.algorithmname}</div>
                  </div>
                  <div className="algorithmToolsSharing-detail-modal-tool-version-wrap">
                    <div className="algorithmToolsSharing-detail-modal-tool-version-title">工具版本:</div>
                    <div className="algorithmToolsSharing-detail-modal-tool-version-vaiue">{this.state.currentCheckedItem.version}</div>
                  </div>
                  <div className="algorithmToolsSharing-detail-modal-tool-author-wrap">
                    <div className="algorithmToolsSharing-detail-modal-tool-author-title">工具作者:</div>
                    <div className="algorithmToolsSharing-detail-modal-tool-author-vaiue">{this.state.currentCheckedItem.author}</div>
                  </div>
                  <div className="algorithmToolsSharing-detail-modal-tool-dllname-wrap">
                    <div className="algorithmToolsSharing-detail-modal-tool-dllname-title">运行程序名:</div>
                    <div className="algorithmToolsSharing-detail-modal-tool-dllname-vaiue">{this.state.currentCheckedItem.dllname}</div>
                  </div>
                </div>
              </div>
              <div className="algorithmToolsSharing-detail-modal-bootom-area">
                <div className="algorithmToolsSharing-detail-modal-bootom-area-introduce-title">简介</div>
                <div className="algorithmToolsSharing-detail-modal-bootom-area-introduce-value">{this.state.currentCheckedItem.introduce?this.state.currentCheckedItem.introduce:'暂无简介'}</div>
              </div>
            </> : <>
              <div className="algorithmToolsSharing-detail-modal-empty">
                暂无内容
              </div>
            </>
          }
        </Modal>
        <DownloadFileComponent
          orderList={this.state.downloadList}
          userScore={this.state.userScore}
          totalScore={this.state.downLoadTotalScore}
          resourceType={"通用工具检验数据"}
          showDownLoadModalFlag={this.state.isDownloadModalShown}
          closeDownLoadModal={() => this.closeDownLoadModal()}
          clearAlgCheckedList={() => this.clearAlgCheckedList()}
        ></DownloadFileComponent>
      </div>
    )
  }
}
const mapState = (state) => ({ //返回值  对应的是  组件的props  
  user: state.userReducer.get('user').toJS(),
  zd_user: state.userReducer.get('zd_user').toJS(),
})
export default connect(mapState)(AlgorithmToolsSharing)